import * as React from 'react';
import CountryService from '../../../../services/CountryService';
import CountrySelect from './components/CountrySelect';
import FlashStore from '../../../../services/FlashStore';
import Image from '../../../Image';
import { observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface ICountryProps {

}

interface ICountryState {
  modalOpened: boolean;
}

@observer
class Country extends React.Component<ICountryProps  & RouteComponentProps, ICountryState> {

  constructor(props: ICountryProps  & RouteComponentProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.toggleModalOpen = this.toggleModalOpen.bind(this);
  }

  public render() {
    const country = CountryService.GetInstance().country;

    if (!country) {
      return null;
    }

    return (
      <>
        {country && <div className={'header__countrySelect'}>
          <span onClick={this.toggleModalOpen}>
            {country.flag &&
              <span id="country_flag"><Image image={country.flag} /></span>}
            <span>{country.name}</span>
          </span>

          {this.state.modalOpened &&
            <CountrySelect 
              onClose={this.toggleModalOpen}
            />}
        </div>}
      </>
    );
  }

  private toggleModalOpen() {
    const pathname = this.props.location.pathname;
    if (pathname === '/payment-and-shipping' || pathname === '/personal-data') {
      FlashStore.GetInstance().showMessage('You can’t change the store origin at this stage. Go back to the cart page—store origin is locked after that.', 'error', 3000);
      return;
    }

    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }
}

export default withRouter(Country);


// WEBPACK FOOTER //
// ./src/components/Header/components/Country/Country.tsx